import { COLOR } from '@app/constant/ColorDefault'
import { InertiaLink } from '@inertiajs/inertia-react'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

export default function HeaderComponent() {
  const { t } = useTranslation()
  return (
    <Button
      component={InertiaLink}
      href={route('admin.vouchers.create')}
      sx={{
        backgroundColor: COLOR.GREY300,
        color: 'black',
        ':hover': {
          backgroundColor: COLOR.GREY400,
        },
      }}
      variant="contained"
    >
      {t('BUTTON.ADD_VOUCHER')}
    </Button>
  )
}
